import React , { lazy } from 'react'

const ViewLeaderboard = lazy(() => import('@/pages/leaderboard'))

export default [
  {
    path: '/c/leaderboard',
    element: <ViewLeaderboard />,
  },
]
